import React, { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import RichTextEditorWithCounter from '../../../../components/admin/property/components/RichTextEditorWithCounter';

const DescriptionSection = () => {
  const { control } = useFormContext();

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h3 className="text-lg font-semibold mb-4 pb-2 border-b">Descrizione</h3>
      
      <div>
        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <RichTextEditorWithCounter
              value={field.value || ''}
              onChange={(value) => {
                // Use this approach to avoid focus loss
                field.onChange(value);
              }}
              maxLength={800}
            />
          )}
        />
      </div>
    </div>
  );
};

export default memo(DescriptionSection);